import React from 'react'

export default () => (
  <svg width="20px" height="20px" viewBox="0 0 20 20">
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="icon/plus" fill="#C02D45">
        <rect id="Rectangle-19" x="9" y="0" width="2" height="20" />
        <rect
          id="Rectangle-19"
          transform="translate(10.000000, 10.000000) rotate(90.000000) translate(-10.000000, -10.000000) "
          x="9"
          y="0"
          width="2"
          height="20"
        />
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/icons/plusIcon.js